import * as React from 'react';
import {
  Alert, Button, Card, Snackbar, Typography,
} from '@mui/material';
import { Box } from '@mui/system';
import lottiesuccess from './Assets/lottie-animation.svg';
import {
  OrderCancelledStyles,
  STORE_TASKID,
} from './constants';
import tickgreen from './Assets/tickgreen.svg';

const OrderStatusPage = () => {
  const [closeAlert, setCloseAlert] = React.useState(false);
  const rnrStatus = localStorage.getItem(`RNR_${localStorage.getItem(STORE_TASKID)}`);

  function getStatusText() {
    if (rnrStatus === 'RNR') {
      return 'marked as customer not responding';
    }
    return '';
  }

  return (
    <Box sx={OrderCancelledStyles.OrderCancelledContainer}>
      <Box sx={OrderCancelledStyles.CardContainer}>
        <Card elevation={0} sx={OrderCancelledStyles.SuccessCard}>
          <img
            src={lottiesuccess}
            alt="lottiesuccess"
            height={80}
            width={80}
            id="lottiesuccess"
          />
          <Typography sx={OrderCancelledStyles.SuccessDetails}>
            {`Order ${getStatusText()}`}
          </Typography>
        </Card>
      </Box>
      <Box sx={OrderCancelledStyles.ActionBottomContainer}>
        <Box sx={OrderCancelledStyles.ActionButton}>
          <Button
            sx={OrderCancelledStyles.ActionRight}
            onClick={() => {
              setCloseAlert(true);
            }}
          >
            <Typography sx={OrderCancelledStyles.ActionRightText}>
              Done
            </Typography>
          </Button>
        </Box>
      </Box>
      <Snackbar
        open={closeAlert}
        sx={OrderCancelledStyles.Snackbar}
        autoHideDuration={2000}
        onClose={() => setCloseAlert(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          severity="success"
          sx={OrderCancelledStyles.Alert}
          icon={
            <img src={tickgreen} alt="" height={24} width={24} id="tick-icon" />
          }
        >
          <Typography sx={OrderCancelledStyles.AlertTypo}>
            Completed! You can close this window.
          </Typography>
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default OrderStatusPage;
